<template>
  <div class='recruitersApply'>
    <section class="apply-sec">
      <div class="w1200  apply-bg">
        <div class="form-box columnbox">
          <form class="betweenbox flex form-ul wrapbox">
            <h3 class="centerbox">申请职位</h3>

            <div class="form-item flexbox">
              <label>姓&ensp;名</label>
              <el-input v-model="form.name" placeholder="请输入真实姓名" class="form-input"></el-input>
            </div>
            <div class="form-item flexbox">
              <label>年&ensp;龄</label>
              <el-input v-model="form.age" placeholder="请输入真实年龄" class="form-input" type="number"></el-input>
            </div>

            <div class="form-item flexbox">
              <label>性&ensp;别</label>
              <el-select v-model="form.sex" placeholder="请选择性别" popper-class="dropdown">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>

            <div class="form-item flexbox">
              <label>学&ensp;历</label>
              <el-input v-model="form.qualification" placeholder="请输入学历" class="form-input"></el-input>
            </div>
            <div class="form-item flexbox">
              <label>工作年限</label>
              <el-input v-model="form.workYear" placeholder="请输入工作年限" class="form-input"></el-input>
            </div>
            <div class="form-item flexbox">
              <label>联系电话</label>
              <el-input v-model="form.tel" placeholder="请输入联系电话" class="form-input" type="tel"></el-input>
            </div>

            <!-- <div class="form-item flexbox text-item align-start">
                                                                      <label>个人描述</label>
                                                                      <textarea type="text" class="form-text" placeholder="简述个人相关工作经历"></textarea>
                                                                    </div> -->
            <div class="form-item flexbox formTextarea">
              <label>个人描述</label>
              <div class="form-text">
                <!-- :autosize="{ minRows: 2, maxRows: 4}"  -->
                <el-input type="textarea" autosize placeholder="简述个人相关工作经历" v-model="form.experience">
                </el-input>
              </div>

            </div>

          </form>
          <a class="en-btn centerbox">提交信息</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "职位申请-益超",
      meta: [
        { name: "keywords", content: "keyword1, keyword2, keyword3" },
        { name: "description", content: "Page description" },
      ],
    };
  },
  mounted() {
    // const element = getScrollParent(this.$el)
    // element.scrollTop = 0
  },
  data() {
    return {
      form: {
        name: '',
        age: '',
        sex: '',
        qualification: '',
        workYear: '',
        tel: '',
        experience: ""
      },
      options: [{
        value: 'man',
        label: '男'
      }, {
        value: 'woman',
        label: '女'
      }],


    }
  },
  created() {
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/base.less";
@media only screen and (min-width: 960px) {
  .dropdown {
    .el-select-dropdown__item {
      padding-left: 16px;
    }
  }
}

@media screen and (max-width:959px) and (min-width:320px) {
  .dropdown {
    .el-select-dropdown__item {
      padding-left: .88rem;
    }
  }
}

.recruitersApply {
  width: 100%;
  .en-btn {
    background: #007edd;
    color: #fff;
  }
  .apply-sec {
    width: 100%;
    background: url(../../assets/images/apply-bg.jpg) center center no-repeat;
    background-size: cover;
    position: relative;
    .apply-bg {
      height: auto;
      background: rgba(255, 255, 255, .96);
      position: absolute;
      top: 51.3%;
      left: 50%;
      transform: translate(-50%, -50%);
      -webkit-transform: translate(-50%, -50%);

      .form-box {
        width: 100%;
        color: #646464;
      }
      .form-box .form-ul {
        font-size: inherit;
        color: inherit;
      }
      .form-box .form-ul h3 {
        width: 100%;
        border-bottom: 1PX solid #d2d2d2;
      }
      .form-box .form-ul .form-item label {
        text-align: right;
      } // 修改placeholder颜色
      /deep/input::-webkit-input-placeholder,
      textarea::-webkit-input-placeholder {
        color: #333;
      }
      /deep/input::-moz-input-placeholder,
      textarea::-moz-input-placeholder {
        color: #333;
      }
      /deep/input::-ms-input-placeholder,
      textarea::-ms-input-placeholder {
        color: #333;
      }

      /deep/textarea::-webkit-input-placeholder {
        color: #333;
      }
      /deep/textarea::-moz-input-placeholder {
        color: #333;
      }
      /deep/textarea::-ms-input-placeholder {
        color: #333;
      }

      .formTextarea {
        width: 100%;
        margin-bottom: 0;
        .form-text {
          border: 1PX solid #d2d2d2;
          background: transparent;
        }
      } // .form-box .form-ul .text-item {
      //   width: 100%;
      //   margin-bottom: 0;
      // } 
      // .form-box .form-ul .text-item textarea {
      //   color: #333;
      //   border: 1PX solid #d2d2d2;
      //   overflow-x: hidden;
      //   overflow-y: auto;
      //   background: transparent;
      // }
    }
  }
  @media only screen and (min-width: 960px) {
    .apply-sec {
      height: 768PX;
      // margin-top: 0;
      margin-top: 80PX;
      .apply-bg {
        padding: 0 100PX 30PX 100PX;
      }
      .form-item .form-input {
        width: 360PX;
        height: 36PX !important;
        padding-right: 16PX;
        padding-left: 16PX;
        border: 1PX solid #d2d2d2;
        /deep/ .el-input__inner {
          border: none;
          height: 100%;
          width: 100%;
          line-height: 1;
          padding: 0;
          border-radius: 0;
          color: #333;
          background: transparent;
        }
      }
      .form-item .el-select {
        width: 360PX;
        height: 36PX !important;
        border: 1PX solid #d2d2d2;
        /deep/.el-input {
          height: 100%;
          width: 100%;
          line-height: 1;
        }
        /deep/.el-input__inner {
          margin-left: 16PX;
          border: none;
          height: 100%;
          width: 100%;
          line-height: 1;
          padding: 0;
          border-radius: 0;
          color: #333;
          background: transparent;
        }
        /deep/.el-input__suffix {
          display: flex;
          align-items: center;
        }
        /deep/.el-input__suffix-inner {
          display: inline-block;
        }
        /deep/.el-input__icon {
          line-height: inherit;
        }
      }

      .formTextarea {
        width: 100% !important;
        margin-bottom: 0 !important;
        height: 246PX !important;
        .form-text {
          width: calc(100% - 90PX);
          height: 246PX;
          padding-right: 16PX;
          padding-left: 16PX;
          color: #333;
          padding-top: 10PX;
          .el-textarea {
            width: 100%;
            height: 100%;
            /deep/ .el-textarea__inner {
              height: 100% !important;
              border: none;
              padding: 0;
              background: transparent;
            }
          }
        }
      }


      .form-box {
        font-size: 16PX;
        .form-ul {
          h3 {
            height: 64PX;
            font-size: 20PX;
            margin-bottom: 40PX;
          }
          .form-item {
            width: 450PX;
            height: 36PX;
            margin-bottom: 30PX;
          }
          .form-item label {
            width: 90PX;
            padding-right: 16PX;
            line-height: 36PX;
          }
          .text-item {
            height: 246PX;
          }
        }
      }
      .en-btn {
        width: 120PX;
        height: 40PX;
        border-radius: 20PX;
        font-size: 16PX;

        margin: 20PX auto;
        margin-top: 40PX;
      }
    }
  }
  @media screen and (max-width:959px) and (min-width:320px) {
    .apply-sec {
      height: auto;
      margin-top: 3.52rem;
      padding: 1.44rem;
      .apply-bg {
        padding: 0 1.2rem 1.2rem 1.2rem;
        position: relative;
        top: auto;
        left: auto;
        transform: translate(0, 0);
        -webkit-transform: translate(0, 0);
      }
      .form-box {
        font-size: 16PX;
        .form-ul {
          h3 {
            height: 2.92rem;
            font-size: .96rem;
            margin-bottom: 1.44rem;
          }
          .form-item {
            width: 100%;
            height: 2.16rem;
            margin-bottom: 1.2rem;
          }
          .form-item label {
            width: 5.6rem; // width: 3.84rem;
            padding-right: 0.96rem;
            line-height: 2.16rem;
            font-size: 0.96rem;
          }
          .form-item .form-input {
            width: calc(100% - 5.6rem); // width: calc(100% - 3.84rem);
            height: 1.84rem;
            padding-right: 0.88rem;
            padding-left: 0.88rem;
            border: 1PX solid #d2d2d2;
            /deep/ .el-input__inner {
              border: none;
              width: 100%;
              height: 100%;
              padding: 0;
              line-height: 1;
              font-size: 0.96rem;
              background: transparent;
            }
          }
          .text-item {
            height: 14.4rem;
          }

          .formTextarea {
            width: 100% !important;
            margin-bottom: 0 !important;
            height: 13.76rem !important;
            .form-text {
              width: calc(100% - 3.84rem);
              height: 13.76rem;
              padding-right: 0.88rem;
              padding-left: 0.88rem;
              color: #333;
              padding-top: 0;
              font-size: 0.96rem;
              line-height: 2.16rem;

              .el-textarea {
                width: 100%;
                height: 100%;
                /deep/ .el-textarea__inner {
                  height: 100% !important;
                  border: none;
                  background: transparent;
                  padding: 0;
                }
              }
            }
          }
        }
      }

      .en-btn {
        width: 6.24rem;
        height: 2.248rem;
        border-radius: 30PX;
        background: #007edd;
        font-size: 0.96rem;
        margin-top: 1.6rem;

        margin: 20PX auto;
      }
    }
  }
}
</style>